import { createRouter, useRouterState } from '@tanstack/react-router'
// Import the generated route tree
import { routeTree } from './routeTree.gen'
import type { RouteIds } from '@tanstack/react-router'
import type { ReactNode } from 'react'
import { LoadingAnimation } from '@odmonorepo/core-components'
import { Stack } from 'react-bootstrap'
import { queryClient } from 'merchant-api'
import type { RootRouteContext } from './routes/__root'

type RouterLoadingState = {
  isLoading: boolean;
  matches: unknown[];
};

const useRouterLoadingState = useRouterState as unknown as (options: { select: (state: RouterLoadingState) => boolean }) => boolean;

const LoadingFallback = () => (
  <Stack><LoadingAnimation className="m-auto" /></Stack>
);

const RouterShell = ({ children }: { children: ReactNode }) => {
  const showLoading = useRouterLoadingState({
    select: (s) => s.isLoading && s.matches.length === 0,
  });
  return (
    <>
      <div style={{ display: showLoading ? 'none' : undefined }}>{children}</div>
      {showLoading && <LoadingFallback />}
    </>
  );
};

// Set up a Router instance
export const router = createRouter({
  routeTree,
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
  context: {
    queryClient,
    applicationId: undefined,
  } satisfies RootRouteContext,
  defaultPendingMs: 0,
  defaultPendingComponent: LoadingFallback,
  InnerWrap: RouterShell,
})

export type RouterType = typeof router
export type RouterIds = RouteIds<RouterType['routeTree']>

// Register the router instance for type safety.
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
